module.exports = __webpack_public_path__ + "static/media/card-cancel.756d6ef2.svg";